import React from 'react'
import './Background.css'
const Background = (props) => (<div className='dark-background'>
    {props.children}
  </div>);
export default Background;
